import { useState } from 'react';
import { Stack, Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useSelector, useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { appSliceActions } from '../../appSlices/appSlice';
import axiosInstance from '../../utils/axiosInstance';
import fetchDeviceList from '../../utils/fetchDeviceList';
import fetchStreamList from '../../utils/fetchStreamList';
import SingleSelector from '../single-selector/singleSelector';

export default function RemoveSensor() {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [sensor, setSensor] = useState(null);
  const sensorList = useSelector((state) => state.app.sensorList);

  const removeSensorApi = () => {
    axiosInstance
      .delete(`${window.location.protocol}//${sensor.host}/api/v1/sensor/${sensor.sensorId}`, { headers: { "streamId": sensor.sensorId } })
      .then(async () => {
        enqueueSnackbar(`Success - remove sensor ${sensor.name}`, {
          variant: 'success',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
        setSensor(null);
        dispatch(appSliceActions.removeDevice(sensor));
        const sensorList = await fetchDeviceList(sensor.host);
        if (sensorList != null) {
          for (let i = 0; i < sensorList.length; i += 1) {
            sensorList[i].host = sensor.host;
          }
          dispatch(appSliceActions.addDevice(sensorList));
        }
        const streamList = await fetchStreamList(sensor.host);
        if (streamList != null) {
          for (let i = 0; i < streamList.length; i += 1) {
            streamList[i].host = sensor.host;
          }
          dispatch(appSliceActions.addStream(streamList));
        }
      })
      .catch((error) => {
        if (error.response.data == null)
          enqueueSnackbar(`Error - ${error.response.status}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        else
          enqueueSnackbar(`Error - ${error.response.data.error_message}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
      });
  };

  const handleSubmit = () => {
    enqueueSnackbar(`Pending - remove sensor`, {
      variant: 'info',
      anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
    });
    if (!sensor) {
      enqueueSnackbar(`Error - Please select sensor`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      return;
    }
    removeSensorApi();
  };

  return (
    <>
      <Stack spacing={3} sx={{ mb: 2 }}>
        <SingleSelector
          id="remove-sensors"
          placeholder="Type to search"
          label="Select sensor"
          value={sensor}
          onChange={setSensor}
          getOptionLabel={(option) => {
            if (option.remoteDeviceName && option.remoteDeviceLocation) {
              return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
            } if (option.remoteDeviceName) {
              return `${option.name} at ${option.remoteDeviceName}`;
            }
            return option.name;

          }}
          options={sensorList}
        />
      </Stack>
      <Box m={1} display="flex" justifyContent="flex-end" alignItems="flex-end">
        <LoadingButton size="large" type="submit" variant="contained" onClick={handleSubmit}>
          Remove
        </LoadingButton>
      </Box>
    </>
  );
}
